import dayjs from 'dayjs';

const getDeviceDormantUnix = () => {
  return dayjs().subtract(7, "days").unix();
};

export default {
  getDeviceDormantUnix
};
